import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';

// Components
import CustomPopover from '@/components/composite/Popover/CustomPopover';
import TagsPopover from '@/components/pages/media/components/TagsPopover';

const AddTags = ({
    selectedMediaIds,
    availableTags,
    mediaTags,
    mutateLibraryMedia,
    renderButton,
    container = document.body,
    displayOnlyAddedTags = false
}) => {
    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const [referenceElement, setReferenceElement] = useState();

    const [popperElement, setPopperElement] = useState();
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10]
                }
            }
        ]
    });
    const popperStylesWithZIndex = {
        arrow: { ...styles.arrow },
        reference: { ...styles.reference },
        popper: { zIndex: 100, ...styles.popper }
    };

    return (
        <>
            {renderButton(setReferenceElement, () => setPopoverOpen(true))}
            {isPopoverOpen && selectedMediaIds.length > 0 && container
                ? ReactDOM.createPortal(
                      <CustomPopover
                          open={isPopoverOpen}
                          popperElement={popperElement}
                          setPopperElement={setPopperElement}
                          toggle={() => setPopoverOpen(false)}
                          styles={popperStylesWithZIndex}
                          attributes={attributes}
                          isBorder>
                          <TagsPopover
                              selectedMediaIds={selectedMediaIds}
                              mutateLibraryMedia={mutateLibraryMedia}
                              availableTags={availableTags}
                              mediaTags={mediaTags}
                              displayOnlyAddedTags={displayOnlyAddedTags}
                          />
                      </CustomPopover>,
                      container
                  )
                : null}
        </>
    );
};

export default AddTags;
